import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { beheertLeden } from '../helpers/leden';

/**
 * De pagina Users (/users): voor een club_admin en een teambeheerder. Anders
 * terug naar de start. Auth kijkt het bij elke aanvraag ook zelf na.
 */
export const ledenGuard: CanActivateFn = () =>
  beheertLeden(inject(AuthService).user) || inject(Router).createUrlTree(['/']);
